import { LessonDefinition } from "../../types";

const lesson: LessonDefinition = {
  id: "checklists",
  courseId: "your-style",
  order: 4,
  title: "Checklists",
  summary:
    "Your agency's checklist lists what a report type has to cover. You complete it before you record, and the AI drafts with your answers in hand.",
  learn: [
    "Start a case from a checklist template",
    "Complete the checklist and move to recording",
    "Use the Checklist tab in the editor",
  ],
  minutes: 3,
  releasedAt: "2025-06-01T00:00:00.000Z",
  gate: "agency",
  body: [
    {
      type: "paragraph",
      text: "Your agency admin builds checklists. Each has categories of items such as \"Elements of the offense\" or \"Evidence collected\", some required and some with a notes field. The **Checklist** option in the **New Case** menu appears only when your department has at least one template.",
    },
    {
      type: "steps",
      items: [
        "Click **New Case**, then **Checklist**.",
        "Pick a template in the \"Select Checklist Template\" modal.",
        "Work through the items. Tick every required item, and type a short answer where an item has notes enabled.",
        "Click **Complete Checklist**. The New Case options open: record, upload, or start blank.",
        "In the editor, open the **Checklist** tab in the right panel to confirm the narrative covers each item.",
      ],
    },
    {
      type: "paragraph",
      text: "Your checklist travels with the case, so the draft is written with your answers available.",
    },
    {
      type: "callout",
      tone: "tip",
      text: "Read the checklist before you press record, then dictate in its order. The draft comes out structured the way the department expects.",
    },
    {
      type: "callout",
      tone: "note",
      text: "Uploading audio to a checklist case saves the checklist answers first and then starts processing, so a brief pause between completing the checklist and the processing screen is normal.",
    },
  ],
  related: ["department-preferences-templates-checklists", "first-narrative-report"],
};

export default lesson;
